import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import * as emailjs from 'emailjs-com';
import { navigate } from '@reach/router';

class SendEmail extends React.Component {
  state = {
    disabledButton: false,
  };

  handleSendEmail = async () => {
    const { template, data } = this.props;
    this.setState({ disabledButton: true });
    emailjs
      .send('gmail', template, data, 'user_fwg01bXPY4ez8aRWQzwfN')
      .then(() => {
        this.setState({ disabledButton: false });
        navigate('/ok');
      })
      .catch((err) => {
        console.log(err); // eslint-disable-line no-console
        this.setState({ disabledButton: false });
      });
  };

  render() {
    const { disabled } = this.props;
    const { disabledButton } = this.state;

    console.log(disabled);

    return (
      <React.Fragment>
        <h4>Odešlete žádost a následně budete kontaktováni s návrhem termínů možné schůzky.</h4>
        <ButtonBox disabledButton={disabledButton}>
          <Button variant='outlined' onClick={this.handleSendEmail} disabled={disabled}>
            Odeslat žádost o schůzku
          </Button>
        </ButtonBox>
      </React.Fragment>
    );
  }
}

SendEmail.propTypes = {
  data: PropTypes.shape({}).isRequired,
  disabled: PropTypes.bool.isRequired,
  template: PropTypes.string,
};
SendEmail.defaultProps = {
  template: 'template_Tjo8lRs4',
};

export default SendEmail;

const ButtonBox = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 24px;
  z-index: ${(props) => (props.disabledButton ? '-1' : 0)};
  cursor: ${(props) => (props.disabledButton ? 'not-allowed' : '')};
`;
